import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import CatalogTable from "../components/tables/CatalogTable";

export default function CatalogPage() {
    return (
        <>
            <PageMeta
                title="Catalog Management | Shoplattice Admin Dashboard"
                description="Manage Brands, Categories, and Products"
            />
            <PageBreadcrumb pageTitle="Catalog Management" />
            <div className="space-y-6">
                <CatalogTable />
            </div>
        </>
    );
}
